import { EarthlySectionComponentProps } from "../../types";
import Section from "../../common/Section/Section";
import { Pillars } from "../../../../types";
import { buildBenefitsFields } from "../../../fields/benefits";
import PillarBenefits from "../../common/BenefitsDisplay/BenefitsDisplay";

function Benefits({ details, onEdit }: EarthlySectionComponentProps) {
  const { pillars } = details;

  return (
    <Section
      title="Benefits"
      columns={2}
      fields={buildBenefitsFields(pillars)}
      onEdit={() => onEdit("benefits")}
      reference={[
        {
          type: "component",
          place: "beneath",
          index: 0,
          item: <PillarBenefits pillars={pillars as Pillars} />,
        },
      ]}
    />
  );
}

export default Benefits;
